import { useMemo } from 'react';
import { LANGUAGE, LOCALE_CN } from '../config';
import { IFormatMessageOptionType } from '../type';
const { en = {}, cn = {} } = LANGUAGE;

export default (locale: string, language: any) => {
  const formatMessage = useMemo(() => {
    const { en: outEn = {}, cn: outCN = {} } = language || {};
    const mergeEn = {
      ...en,
      ...outEn,
    };
    const mergeCn = {
      ...mergeEn,
      ...cn,
      ...outCN,
    };
    const message = locale === LOCALE_CN ? mergeCn : mergeEn;
    return (option: IFormatMessageOptionType): string => {
      const { id } = option;
      return message?.[id];
    };
  }, [locale, language]);

  return {
    formatMessage,
  };
};
